# INFO: resumes don't have much space (trimmed lots of things out)
basics:
  # name: Lucas Fernando C. Nunes
  name: Lucas F. C. Nunes
  labels:
    - name: IT Generalist
      url: https://en.wikipedia.org/wiki/Information_technology_generalist
    # - name: IT Supervisor
    #   url: "https://en.wikipedia.org/wiki/Supervisor"
    #   url: "https://jobdescription.org/job-descriptions/information-technology-supervisor-job-description-it-industry"
  picture: ""
  website: https://lucasfcnunes.com
  summary: ""
  location:
    address: ""
    postalCode: "21"
    city: Rio de Janeiro, RJ
    countryCode: BR
    region: ""
  profiles:
    - network: email
      username: contact@lucasfcnunes.com
    # - network: email
    #   username: lucasfc.nunes@gmail.com
    # - network: phone
    #   username: +55 21 97431-1445
    - network: whatsapp
      username: +55 21 97431-1445
    - network: linkedin
      username: lucasfcnunes
    - network: github
      username: lucasfcnunes
    # - network: telegram
    #   username: lucasfcnunes
    # - network: x
    #   username: lucasfcnunes
work:
  - company: Incentive.me
    position: IT Supervisor
    website: https://incentive.me
    startDate: 2020-06
    endDate: 2025-08
    summary: IT Supervisor of IT Infrastructure, IT Security, BI and Data Engineering teams. Responsible for the architecture, development of internal tools and infrastructure.
    highlights:
      - Management focusing in promoting top IT Infrastructure, IT Security and Data Analysis/Engineering.
      - Startup environment with 100+ employees and 4 teams under my management.
      - Hands-on role with a lot of technical involvement in the projects and processes of the teams.
      - Heavy FOSS usage in the stack for budget optimization.
      - Leadership, communication, problem solving, project management (with 4 teams with at least 2 members each simultaneously).
      - Architected and implemented data pipeline using Airflow, dbt and ClickHouse, etc which is responsible for the processing of all the company's data and is used by multiple teams for analytics and reporting.
      - Refactoring core things from Manual to IaC
  - company: LUCASFCNUNES
    position: Owner
    website: https://lucasfcnunes.com
    startDate: 2020-06
    endDate: present
    summary: Consulting, B2B contracting, freelancing and open source contributions.
    highlights: []
  - company: Procter & Gamble (P&G)
    # position: Electronics Technician - Trainee
    position: Technician - Trainee
    website: https://pg.com
    startDate: 2016-10
    endDate: 2018-10
    summary: Responsible for the development of internal tools and automation of processes using Python, C++ and Power BI.
    highlights:
      - Sole author/developer of an automated Zebra Printer GHS solution which was implemented in multiple plants.
      - Automation/spreadsheet geek/go-to.
      - Brazilian Touchless Production initiative member.
      - Master Production Schedule (MPS) optimization research.
      - In touch with SAP, HMI and production Ladder code.
volunteer:
  - organization: redash
    position: Org. Member
    website: https://redash.io
    startDate: 2023-03
    endDate: present
    summary: A popular (28k+ stars on GitHub) FOSS web based data visualization and dashboarding tool with many popular database connectors.
    highlights: []
education:
  - institution: Universidade Federal do Rio de Janeiro (UFRJ, Escola Politécnica, DEL)
    area: Electronics and Computer Engineering
    studyType: Bachelor
    startDate: 2017-01
    endDate: ~2021 (never finished)
    # website: https://www.del.ufrj.br/
    # website: https://poli.ufrj.br/
    website: https://ufrj.br/en/
    courses: []
      # - All calculus and physics (theoretical and experimental) courses
    summary: I completed about three and a half years of engineering studies, though I didn't finish the degree. During that time, I built a strong foundation in both the theoretical and practical sides of engineering and scientific research.
  - institution: Centro Federal de Educação Tecnológica (CEFET/RJ)
    area: Electronics
    studyType: Technician
    startDate: 2013-01
    endDate: 2016-12
    website: https://www.cefet-rj.br/index.php/maracana-campus-headquarter-presentation
    courses:
      - PLC/PIC/Arduino (C/Assembly/Ladder) programming
      - Assembly language
      - Digital electronics
      - much more...
    summary: Technical course in electronics, gaining practical and theoretical knowledge in various areas of electronics and programming.
skills:
  - name: IT Infrastructure
    level: Proficient
    keywords:
      # - Infrastructure as Code (Crossplane/Terraform/Ansible)
      - IaC
      # - Corporate architectures with heavy FOSS usage
      - FOSS based arch
      - FinOps
      - IT budget management
      - Kubernetes
      # - Docker
      # - Linux
      # - GCP/Azure
      - Cloud
      # - VMs (including Proxmox, Windows and MacOS)
      # - DNS/Networking
      # - Grafana/Prometheus/OTel
      # - OpenSearch/ES
      # - Cilium/Hubble/Tetragon/eBPF
      # - GitHub Actions
      # - Zero Trust
      # - Nix (recently)
  - name: IT Security
    level: Proficient
    keywords:
      - SOC2
      - ISO27001
      - OWASP
      - Incident response
      # - Vulnerability management
      # - Security monitoring/architecture
      # - Threat modeling
      - Risk assessment
      # - Onboarding/Offboarding
      # - Penetration testing
      # - SAST/DAST
  - name: Data Engineering
    level: Proficient
    keywords:
      - Airflow/Composer
      - MySQL
      - PostgreSQL
      - ClickHouse
      # - Mongo
      - DB tuning/optimization/recovery
      - Data modeling
      - Data pipelines
      # - dbt
      # - Spark
      # - DataHub
  - name: BI
    level: Proficient
    keywords:
      - Power BI (PQ, DAX, Formula, VBA)
      - Reporting
      - Python
      - R
      - SQL
      - Redash
      - Metabase
      - Excel
  # - name: Backend Development
  #   level: Advanced reviewing
  #   keywords:
  #     - Designing and reviewing backend systems and APIs
  #     - Python
  #     - Go
  #     - JS/TS
languages:
  # - language: Portuguese (BR)
  #   fluency: Native
  - language: Portuguese
    fluency: Native
  - language: English
    fluency: Fluent
  # - language: Japanese
  #   fluency: Intermediate
  # - language: Latin
  #   fluency: Basic
interests:
  - name: FOSS
    keywords:
      # - Open source software
      - Community
      - Giving back
  - name: STEM
    keywords:
      - Science
      - Technology
      - Engineering
      - Mathematics
  # - name: Giving "TED Talks" on
  #   keywords:
  #     - Nix/NixOS
  #     - Kubernetes
  #     - Tailscale/Headscale
  #     - Isovalent/Cilium
  #     - Lean 4
  #     - Pony
  #     - FOSS in general
  #     - Quantum computing
  - name: Hiking
    keywords:
      - Nature
      - Outdoors
      - Mountain
      - Novice
references: []
